import { c as _c } from "react/compiler-runtime";
import { varAlpha } from 'minimal-shared/utils';
import ButtonBase from '@mui/material/ButtonBase';
import IconButton from '@mui/material/IconButton';
import { Iconify } from '../iconify';

// ----------------------------------------------------------------------

export function DownloadButton(t0) {
  const $ = _c(11);
  let other;
  let sx;
  if ($[0] !== t0) {
    ({
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
  } else {
    other = $[1];
    sx = $[2];
  }
  let t1;
  if ($[3] !== sx) {
    t1 = Array.isArray(sx) ? sx : [sx];
    $[3] = sx;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = [_temp, ...t1];
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Iconify icon="eva:arrow-circle-down-fill" width={24} />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== other || $[9] !== t2) {
    t4 = <ButtonBase sx={t2} {...other}>{t3}</ButtonBase>;
    $[8] = other;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(theme) {
  return {
    p: 0,
    top: 0,
    right: 0,
    width: 1,
    height: 1,
    zIndex: 9,
    opacity: 0,
    position: "absolute",
    color: "common.white",
    borderRadius: "inherit",
    transition: theme.transitions.create(["opacity"]),
    "&:hover": {
      ...theme.mixins.bgBlur({
        color: varAlpha(theme.vars.palette.grey["900Channel"], 0.64)
      }),
      opacity: 1
    }
  };
}
export function RemoveButton(t0) {
  const $ = _c(11);
  let other;
  let sx;
  if ($[0] !== t0) {
    ({
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
  } else {
    other = $[1];
    sx = $[2];
  }
  let t1;
  if ($[3] !== sx) {
    t1 = Array.isArray(sx) ? sx : [sx];
    $[3] = sx;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = [_temp2, ...t1];
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Iconify icon="mingcute:close-line" width={12} />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== other || $[9] !== t2) {
    t4 = <IconButton size="small" sx={t2} {...other}>{t3}</IconButton>;
    $[8] = other;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp2(theme) {
  return {
    p: 0.35,
    top: 4,
    right: 4,
    position: "absolute",
    color: "common.white",
    backgroundColor: varAlpha(theme.vars.palette.grey["900Channel"], 0.48),
    "&:hover": {
      backgroundColor: varAlpha(theme.vars.palette.grey["900Channel"], 0.72)
    }
  };
}